import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const SpotprisIdag = lazy(() => import("@/pages/spotpris/SpotprisIdag"));

export const Route = createFileRoute("/spotpris/idag")({
  head: () => seoHead("/spotpris/idag", { description: "Se dagens spotpris timme för timme i SE1, SE2, SE3 och SE4. Priserna kommer från Nord Pool och uppdateras automatiskt." }),
  component: () => <SpotprisIdag />,
});
